var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAuto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "24px",
    viewBox: "0 0 23 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "62.3280288%",
    y1: "-124.564448%",
    x2: "81.2152705%",
    y2: "137.602079%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97D700",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0DC",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "61.5095048%",
    y2: "105.998164%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73CA34",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DAAB0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "36.9135907%",
    y1: "192.735829%",
    x2: "56.5561568%",
    y2: "-16.4441193%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73CA34",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DAAB0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97D700",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0DC",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Auto-recharge/Multicolor/48px"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle",
    fill: "url(#linearGradient-1)",
    transform: "translate(9.915152, 7.311688) rotate(70.000000) translate(-9.915152, -7.311688) ",
    points: "9.91515152 6.12380952 11.7722944 8.4995671 8.05800866 8.4995671"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.766072373,0.170437653 C-1.17437691,8.5783178 4.01578452,9.37070017 9.58248019,7.56638652",
    id: "Path-3",
    stroke: "url(#linearGradient-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(16.000000, 5.000000) rotate(-180.000000) translate(-16.000000, -5.000000) translate(10.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle",
    fill: "url(#linearGradient-3)",
    transform: "translate(9.387785, 7.060513) rotate(70.000000) translate(-9.387785, -7.060513) ",
    points: "9.38778483 5.87263403 11.2449277 8.24839161 7.53064198 8.24839161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.739712483,7.1e-15 C-0.155194784,8.25562731 3.54672096,8.93337008 9.11341663,7.12905644",
    id: "Path-3",
    stroke: "url(#linearGradient-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(6.500000, 5.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mobile"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.09090909,0.830175439 C7.09090909,0.546354776 6.86261641,0.312202729 6.57898004,0.312202729 L0.511929047,0.312202729 C0.228292683,0.312202729 0,0.546354776 0,0.830175439 L0,2.33442495 L7.09090909,2.33442495 L7.09090909,0.830175439",
    id: "Fill-2116",
    fillOpacity: 0.200000003,
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.511929047,12.8357895 L6.57898004,12.8357895 C6.86261641,12.8357895 7.09090909,12.6016374 7.09090909,12.3178168 L7.09090909,10.8135673 L0,10.8135673 L0,12.3178168 C0,12.6016374 0.228292683,12.8357895 0.511929047,12.8357895 Z",
    id: "Fill-2117",
    fillOpacity: 0.200000003,
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2118",
    fill: "#37474F",
    points: "0 2.33442495 7.09090909 2.33442495 7.09090909 10.8135673 0 10.8135673"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.04181872,11.8880663 C4.04181872,12.1833711 3.80203943,12.417154 3.51307463,12.417154 C3.21796166,12.417154 2.97818236,12.1833711 2.97818236,11.8880663 C2.97818236,11.5927616 3.21796166,11.3528265 3.51307463,11.3528265 C3.80203943,11.3528265 4.04181872,11.5927616 4.04181872,11.8880663",
    id: "Fill-2119",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.96363636,1.31976608 C4.96363636,1.43329435 4.88223961,1.53263158 4.782059,1.53263158 L2.30885009,1.53263158 C2.20866948,1.53263158 2.12727273,1.43329435 2.12727273,1.31976608 C2.12727273,1.20623782 2.20866948,1.1139961 2.30885009,1.1139961 L4.782059,1.1139961 C4.88223961,1.1139961 4.96363636,1.20623782 4.96363636,1.31976608",
    id: "Fill-2120",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("g", {
    id: "add",
    transform: "translate(3.714286, 3.714286)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "url(#linearGradient-4)",
    cx: 2.75757576,
    cy: 2.75757576,
    r: 2.75757576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.11759294,2.48947811 L3.11759294,1.29244562 C3.11759294,1.21321721 3.05184488,1.1489899 2.97107522,1.1489899 L2.72791538,1.1489899 C2.64699587,1.1489899 2.58139766,1.206589 2.58139766,1.29244562 L2.58139766,2.48947811 L1.38436516,2.48947811 C1.30513676,2.48947811 1.24090944,2.55522618 1.24090944,2.63599583 L1.24090944,2.87915568 C1.24090944,2.96007518 1.29850854,3.0256734 1.38436516,3.0256734 L2.58139766,3.0256734 L2.58139766,4.2227059 C2.58139766,4.3019343 2.64714572,4.36616162 2.72791538,4.36616162 L2.97107522,4.36616162 C3.05199473,4.36616162 3.11759294,4.30856251 3.11759294,4.2227059 L3.11759294,3.0256734 L4.31462544,3.0256734 C4.39385384,3.0256734 4.45808116,2.95992533 4.45808116,2.87915568 L4.45808116,2.63599583 C4.45808116,2.55507633 4.40048206,2.48947811 4.31462544,2.48947811 L3.11759294,2.48947811 Z",
    id: "Shape",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    fill: "#FFFFFF"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuto);
export default __webpack_public_path__ + "static/media/auto.fb420650dd48658464b23e0e2a0eb705.svg";
export { ForwardRef as ReactComponent };